module.exports = __webpack_public_path__ + "img/chicken.afd9c9b6.svg";